
     
      <template>
        <div></div>
      </template>
      
      <script>
      //import Spinner from '../../../loader/Spinner.vue'
      export default {
        components: {
        //  Spinner,
        },
        data() {
          return {
            //LoadChaussette: false,
          }
        },
        created() {
     
      this.getChausette();
      },
      computed: {
          /** Connecteur A*/
          /*
          StorePkChausette() {
                  return this.$store.state.storeCoA.StorePkChausette
              },
              */
            },
      methods: {
        async getChausette() {
          try {
            //Appel de l'api + transofrmation Json'
            const res = await fetch(this.$store.state.storeGlobal.StoreApi + '/api/preco_chaussette_imgs?' +
          'chaussettes='+ this.$store.state.storeCable.cable.structure.pkStructureId ,{
      method: "GET", // *GET, POST, PUT, DELETE, etc.
      headers: {
      "Accept": "application/json",
      "Content-Type": "application/json; charset=utf-8",
      "Authorization": this.$store.state.storeGlobal.StoreJwtToken
    },
    }
         )
            var resultApi = (await res.json());
          
            var chaussette = resultApi[0];
        
            this.chooseChausette(chaussette.id, chaussette.chaussette , chaussette.img_chaussette_gauche , chaussette.img_chaussette_droite)
            //this.LoadChaussette = true;
          } catch (error) {
            this.answer = 'Error! Could not reach the API. ' + error
          }
        },
//!TODO PAs d'incrément des chausette dans le store' 
        chooseChausette(pkChaussette, typeChaussette , imgChaussetteGauche , imgChaussetteDroite ){
         
          this.obj = {  
          'chaussette' : {
            'chaussette' : {
              pkChaussette:pkChaussette,
              typeChaussette: typeChaussette,
              imgChaussetteGauche: imgChaussetteGauche,
              imgChaussetteDroite: imgChaussetteDroite,
        }
        }};
       
        this.$store.commit('SET_CHOICE_CHAUSSETTE', this.obj )


        }
        
      },
      
      
      }
      </script>